var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"logo_icon",attrs:{"src":require("./images/logo.svg"),"alt":"logo"}}),_c('div',{staticClass:"menus"},[_c('Menus')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }